import type { FpaymentCreditCardInfo, FproductPaymentMethodData, NicedayProductGatewayData } from './api'

/** 信用卡持卡人驗證狀態 */
export enum CardVerifiedStatus {
  /** 未驗證 */
  NOT_VERIFIED = 0,
  /** 已驗證 */
  VERIFIED = 1,
}

/** 支付渠道類型 */
export enum CardGatewayType {
  /** TapPay */
  TAP_PAY = 0,
  /** Stripe */
  STRIPE = 1,
}

/** 持卡人資訊 */
export interface CardholderInfo {
  /** 持卡人姓名（英文） */
  name: string
  /** 發卡銀行留存之手機號碼 */
  phone: string
  /** 發卡銀行留存之 E-mail */
  email: string
}

/**
 * 擴展的信用卡資訊，包含持卡人驗證相關欄位
 * 後端會新增 gateway_type 和 verified_status 欄位
 */
export interface CreditCardInfoWithVerification extends FpaymentCreditCardInfo {
  /** 支付渠道類型：0=TapPay, 1=Stripe */
  gateway_type?: CardGatewayType
  /** 持卡人驗證狀態：0=未驗證, 1=已驗證 */
  verified_status?: CardVerifiedStatus
}

export enum CardType {
  VISA = 1,
  MASTER_CARD = 2,
  JCB = 3,
  UNION_PAY = 4,
  AMEX = 5,
  DISCOVER = 6,
  DINERS = 7,
}

export const CardTypeNameMap: Record<number, string> = {
  [CardType.VISA]: 'visa',
  [CardType.MASTER_CARD]: 'mastercard',
  [CardType.JCB]: 'jcb',
  [CardType.UNION_PAY]: 'unionpay',
  [CardType.AMEX]: 'amex',
  [CardType.DISCOVER]: 'discover',
  [CardType.DINERS]: 'diners',
}

export type BookingPaymentQuery = {
  /** @example '3171471576759' */
  product_id: string | number
  /** @example '204' or 204 */
  amount: string | number
  /** @example '0' */
  currency_id: string | number
  /** @example '2023-09-02 14:30:00' */
  booking_time: string
  /** @example false */
  use_fun_coin: boolean
  /** @example '123431' */
  code_id?: string | number
  /** @example 1 | 0 */
  promo_usage?: 1 | 0
}

export type GatewaysQuery = {
  sale_region_id?: number
}

/** 收款類型 */
export enum PaymentMethodsType {
  NONE = -2,
  SAVED_CREDIT_CARD,
  NEW_CREDIT_CARD,
  /** @deprecated Web 尚未實作  */
  GOOGLE_PAY,
  /** @deprecated Web 尚未實作  */
  APPLY_PAY,
  LINE_PAY,
  /** @deprecated Web 尚未實作  */
  FPX,
  /** @deprecated Web 尚未實作  */
  PI_WALLET,
  /** @deprecated Web 尚未實作  */
  OCTOPUS,
  GRAB_PAY,
  ATM_TO_MERCHANT,
  PROMPT_PAY,
  /** @deprecated TNG 不顯示 payment options */
  TNG,
  /** 分期付款 3 期 */
  THREE_INSTALLMENTS,
}

export interface PaymentMethodData extends Omit<FproductPaymentMethodData, 'type'> {
  type?: PaymentMethodsType
}

export interface ProductGatewayData extends Omit<NicedayProductGatewayData, 'payment_methods'> {
  payment_methods?: PaymentMethodData[]
}
